import React, { Component } from 'react';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import styled from "react-emotion";
import { SmallModal } from "appStyles";

const Container = styled('div')`
  cursor: pointer;
  position: ${props => props.position};
  right: ${props => props.right};
  margin: ${props => props.margin};
`;

class HintModal extends Component {
  state = {
    hideModal: true
  }

  toggleOff = () => {
    this.setState({hideModal: true});
  }

  toggleOn = () => {
    this.setState({hideModal: false});
  }

  render() {
    const {
      hideModal
    } = this.state;

    const {
      width,
      height,
      position,
      containerRight,
      modalLeft,
      margin
    } = this.props;

    return (
      <Container 
        position={position}
        right={containerRight}
        margin={margin}
      >
        <FontAwesomeIcon icon="question-circle" 
          onMouseEnter={this.toggleOn}
          onMouseLeave={this.toggleOff}
        />
        <SmallModal 
          hidden={hideModal}
          left={modalLeft || '25px'}
          top='0'
          width={width}
          height={height}
        >
          {this.props.children}
        </SmallModal>
      </Container>
    );
  }
}

export default HintModal;